import { store } from '~/pages/heineken_template/_private/store';
import { index_trade } from '~/trades/indicators/asiajye_stock/index_trade';
import { stock_power } from '~/trades/indicators/asiajye_stock/stock_power';
import { stock_trade_original } from '~/trades/indicators/asiajye_stock/stock_trade_original';
export const asiajyeStock_strategiesGroup = {
    main: [
        {
            displayName: '-',
            indicators: [stock_trade_original, index_trade, stock_power],
            symbol: 'FDX-1',
            interval: '60',
            panesRatio: 72,
        },
    ],
};
export const asiajyeStock_initStrategies = () => {
    store.charting.indicatorsPreloaded = [
        ...store.charting.indicatorsPreloaded,
        ...[stock_trade_original, index_trade, stock_power],
    ];
    store.charting.initStrategy({
        configs: [...asiajyeStock_strategiesGroup.main],
    });
};
